<div class="cookie"
    [ngStyle]="{'background-color':settingsData.form_bg_color? settingsData.form_bg_color:'','font-family': settingsData.font_family ? settingsData.font_family : '',
    'color': settingsData.form_font_secondary_color ? settingsData.form_font_secondary_color : ''}">
    <div class="pt-100">
        <div class="container">
            <div class="cookie-box">
                <h1 class="text-center ff mb-10" *ngIf="router.url.includes(channel) && channel != '' ">
                    {{performer_details.organization_name}}</h1>
                <div class="text-center" *ngIf="router.url.includes(channel) && channel != '' ">
                    <!-- <img
                        [src]="assets_url + 'Powered by- Arevea.svg'" width="100" class="mb-3"> -->
                <span class="mb-3" *ngIf="!settingsData?.form_font_secondary_color"><app-svg [icon]="'powered-by-bigbee'"></app-svg></span>
                <img class="mb-3" *ngIf="settingsData?.form_font_secondary_color" [src]="clientDetails.header_logo" width="250">
                    </div>
                <h1 class="text-center ff" *ngIf="!router.url.includes(channel) || channel == '' "><span class="text-uppercase">{{clientDetails.name}}</span> INC.</h1>
                <h1 class="text-center ff">COOKIE POLICY</h1>
                <h3 class="text-center ff">Last Updated: January 31, 2021</h3>
                <p>
                    <strong>THIS POLICY SETS FORTH OUR USE OF COOKIES. PLEASE READ IT CAREFULLY. </strong>
                </p>
                <p><br><span class="cookie-p">What is a Cookie?</span><br></p>
                <p>
                    Cookies are small text files that are stored on your computer or mobile device. They are widely used
                    in order to make websites and software applications work, or work in a better, more efficient way.
                    They can do this because websites and software applications can read and write these files, enabling
                    them to recognize you and remember important information that will make your use of a website or
                    software application more convenient (e.g., by remembering your user preferences).
                </p>
                <p><br><span class="cookie-p">What Cookies do we use?</span><br></p>
                <p>
                    Below we list the different types of cookies we may use on the {{clientDetails.name}} Services.
                </p>
                <p>
                    <u>Essential Cookies </u> <br><br>

                    These cookies are essential to the operation of the {{clientDetails.name}} Services in order to enable you to move
                    around it and to use its features. Without these cookies, services you have asked for, such as
                    accessing secure areas of the website or paid for content, cannot be provided. These cookies are
                    essential for using the website and therefore cannot be turned off without severely affecting your
                    use of the website.
                </p>
                <p>
                    <u>Performance Cookies </u> <br><br>

                    Performance cookies, which often include analytics cookies, collect information about your use of
                    this {{clientDetails.name}} Services and enable us to improve the way it works. For example, performance cookies
                    show us which are the most frequently visited pages on the website, allow us to see the overall
                    patterns of usage on the {{clientDetails.name}} Services, help us record any difficulties you have with the
                    {{clientDetails.name}} Services and show us whether our advertising is effective or not.
                </p>
                <p>
                    <u>Functionality Cookies</u> <br><br>

                    In some circumstances, we may use functionality cookies. Functionality cookies allow us to remember
                    the choices you make on the {{clientDetails.name}} Services and to provide enhanced and more personalized
                    features, such as customizing a certain webpage, remembering if we have asked you to participate in
                    a promotion and for other services you request, like watching a video or commenting on a blog. All
                    of these features help us to improve your visit to the {{clientDetails.name}} Service.
                </p>
                <p>
                    <u>Targeting or Advertising Cookies </u> <br><br>

                    We and our service providers may use targeting or advertising cookies to deliver ads that we believe
                    are more relevant to you and your interests. For example, we may use targeting or advertising
                    cookies to limit the number of times you see the same ad on our {{clientDetails.name}} Services and to help
                    measure the effectiveness of our advertising campaigns. These cookies remember what you have looked
                    at on the {{clientDetails.name}} Services and we may share this information with other organizations, such as
                    advertisers.
                </p>
                <p>
                    <u>Flash Cookies</u> <br><br>

                    We may, in certain situations, use Adobe Flash Player to deliver special content, such as video
                    clips or animation. To improve your user experience, Local Shared Objects (commonly known as “Flash
                    cookies”) are employed to provide functions such as remembering your settings and preferences. Flash
                    cookies are stored on your device, but they are managed through an interface different from the one
                    provided by your web browser. This means it is not possible to manage Flash cookies at the browser
                    level, in the same way you would manage cookies. Instead, you can access your Flash management tools
                    from Adobe’s website directly. The Adobe website provides comprehensive information on how to delete
                    or disable Flash cookies see <a [ngStyle]="{'color': settingsData?.footer_font_primary_color}"
                        href="https://adobe.com/security/flashplayer">adobe.com/security/flashplayer</a> for further
                    information. Please be aware that if you disable or reject Flash cookies for the {{clientDetails.name}} Service,
                    you may not be able to access certain features, such as video content or services that require you
                    to sign in.
                </p>
                <p><br><span class="cookie-p">How do third parties use cookies on the site?</span><br></p>
                <p>
                    In some circumstances, we may work with third parties to provide services on the {{clientDetails.name}} Service.
                    For example, developers of Extensions that are used by broadcasters on their {{clientDetails.name}} channels may
                    set cookies to operate those Extensions and remember your user settings and preferences, e.g.,
                    format, position, etc., of the Extension.
                </p>
                <p>
                    In addition, third-party advertisers and other organizations may use their own cookies to collect
                    information about your activities on the {{clientDetails.name}} Services websites and/or the advertisements you
                    have clicked on. This information may be used by them to serve advertisements that they believe are
                    most likely to be of interest to you based on content you have viewed. Third-party advertisers may
                    also use this information to measure the effectiveness of their advertisements.
                </p>
                <p>
                    We do not control these cookies. To disable or reject third-party cookies, please refer to the
                    relevant third party’s website. For Extensions in particular, we encourage you to visit an
                    Extension’s detail pages to review any privacy policy posted by the relevant developer, which may
                    include additional information on their cookie practices. You can also learn more about controlling
                    cookies in the “How do I control Cookies” section below.
                </p>
                <p><br><span class="cookie-p">How do I control Cookies?</span><br></p>
                <p class="mb-0 pb-20">
                    You may refuse to accept cookies from the {{clientDetails.name}} Services or Extension developers at any time by
                    activating the setting on your browser which allows you to refuse cookies. You can refuse to accept
                    Flash cookies from the {{clientDetails.name}} Services or Extension developers using Adobe’s Flash management
                    tools at <a [ngStyle]="{'color': settingsData?.footer_font_primary_color}"
                        href="http://www.adobe.com/security/flashplayer">http://www.adobe.com/security/flashplayer</a>.
                    Further information about the procedure to follow in order to disable cookies can be found on your
                    Internet browser provider’s website via your help screen. Please be aware that if cookies are
                    disabled, not all features of the {{clientDetails.name}} Services or Extension may operate as intended.

                </p>
            </div>
        </div>
    </div>
</div>